export default __webpack_public_path__ + "static/media/logoErr.43e7d053.png";